import { type VariablesOf } from '@graphql-typed-document-node/core'
import React from 'react'
import * as R from 'remeda'
import { type AsyncReturnType } from 'type-fest'

import { graphql } from '~/gql'
import { useGetFigureMeta } from '~/hooks/useGetFigureMeta'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { addProp, FigureInfoHelpers } from '~/utils'

const document = graphql(`
  query DocumentImageArchiveListPage_DocumentImages(
    $brandAccountId: ID!
    $offset: Int! = 0
  ) {
    documentImages(
      brandAccountId: $brandAccountId
      status: archived
      pagination: { limit: 20, offset: $offset }
    ) {
      id
      title
      allMetadata {
        name
        value
      }
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useFetchArchivedDocumentImages = () => {
  const graphQLRequest = useGraphQLRequest()
  const getFigureMeta = useGetFigureMeta()

  return React.useCallback(
    async (variables: Variables) => {
      const result = await graphQLRequest({ document, variables })

      return R.pipe(
        result.documentImages ?? [],
        R.map(
          R.piped(
            addProp('creator', (doc) => FigureInfoHelpers.getCreator(doc)),
            addProp('figureMeta', getFigureMeta),
          ),
        ),
      )
    },
    [getFigureMeta, graphQLRequest],
  )
}

export type DocumentImage = AsyncReturnType<
  ReturnType<typeof useFetchArchivedDocumentImages>
>[number]
